export default __webpack_public_path__ + "static/media/273806-P5X28A-300.c9f6ed67.jpg";